import React, { useState } from "react";

import UploadPopUp from "../UploadModal/UploadPopUp";
import "./UploadButton.css";

const UploadButton = ({ schoolId, selectedEvent, uploadType, selectedTab }) => {
  const [showModal, setShowModal] = useState(false);

  const isWithinNext7Days = () => {
    if (!selectedEvent?.start_date_time) return false;

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const eventDate = new Date(selectedEvent.start_date_time);
    eventDate.setHours(0, 0, 0, 0);

    const sevenDaysFromEvent = new Date(eventDate);
    sevenDaysFromEvent.setDate(eventDate.getDate() + 7);

    return today <= sevenDaysFromEvent;
  };

  const handleUpload = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const isEnabled = selectedTab === "Events" ? isWithinNext7Days() : true;

  if (!schoolId) return null;

  return (
    <div className="upload-button-container">
      <button
        className="upload-button"
        onClick={handleUpload}
        disabled={!isEnabled}
        title={
          !isEnabled
            ? "Upload is only enabled within 7 days from the event's start date"
            : ""
        }
      >
        {(() => {
          switch (selectedTab) {
            case "Events":
              return uploadType === "studentRegister"
                ? "Upload Students"
                : "Upload Responses";
            case "Onboarded Students":
              return "Upload Students";
            default:
              return "Upload Data";
          }
        })()}
      </button>
      {showModal && (
        <UploadPopUp
          handleCloseModal={handleCloseModal}
          schoolId={schoolId}
          selectedEvent={selectedEvent}
          uploadType={uploadType}
          selectedTab={selectedTab}
        />
      )}
    </div>
  );
};

export default UploadButton;
